import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import styles from './index.css'

@withRouter
export default class CodeField extends React.Component {
  
  static propTypes = {
    fullWidth: PropTypes.bool,
    //value : PropTypes.string.isRequired,
    onChange : PropTypes.func,
    onSubmit : PropTypes.func,
    label : PropTypes.string,
    type : PropTypes.string
  }

  static defaultProps = {
    value: '',
    onChange : f=>f,
    onSubmit : () => {}
  }

  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
  }

  onChange(index, value) {
    const newValue = this.props.value.substring(0, index) + value + this.props.value.substring(index+1)
    this.props.onChange(newValue)
  }

  render() {
    let classes = [styles.TextField]

    const { meta } = this.props
    let errorText = null
    if (meta) {
      if (typeof meta.error === 'string') {
        classes.push(styles.error)
        errorText = meta.error
      }
    }
    return (
      <div className={styles.CodeField}>
        {/*
          [0,1,2,3,4,5].map((e,i) => ( 
            <input 
              key={e}
              ref={'CFInput'+i}
              className={classes.join(' ')}
              type={'number'} 
              pattern={'\d*'}
              inputmode={'numeric'}
              value={this.props.value && this.props.value.charAt(i)}
              maxLength={1}
              onKeyDown={e => {
                e = e || window.event 
                console.log(e.keyCode)

                const isBackspace = e.keyCode == 8 || e.keyCode == 229

                if (e.keyCode == 13) {
                  this.props.onSubmit()
                }
                if ( i > 0 && isBackspace && e.target.value == '') {
                  this.refs['CFInput'+(i-1)].focus()
                  return
                }
                if (e.keyCode != 13 && !isBackspace) {
                  this.onChange(i, e.key)
                }
                if (isBackspace) {
                  this.onChange(i, '')
                }
                if ( i < 5 && !isBackspace ) {
                  this.refs['CFInput'+(i+1)].focus()
                }
              }}
             
              />
          ))
          */
        }
        {
          [0,1,2,3,4].map((e,i) => ( 
            <div key={e} className={styles.Impostor}></div>
          ))
        }
        <div className={styles.Impostor} style={{marginRight: '0rem'}}></div>
        {
          <input 
            ref={'Input'}
            className={[classes, this.props.value.length == 6 ? styles.HideCaret : ''].join(' ')}
            type={'tel'} 
            pattern={'\d*'}
            inputMode={'numeric'}
            value={this.props.value}
            maxLength={6}
            minLength={6}
            max={999999}
            onKeyDown={e => {
              e = e || window.event 
              if (e.keyCode == 13) {
                this.props.onSubmit()
              }
            }}
            onChange={(e) => {
              this.props.onChange(e.target.value)
            }}
            />
        }
        { 
          errorText &&
            <div key={3} className={styles.ErrorText}>{errorText}</div>
        }
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/CodeField/index.jsx